import React from 'react';
import { WebsiteDesignProps } from './types';
import { Gem, ShieldCheck, Award } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ExecutiveSuite: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Executive Institute";

    return (
        <div className="bg-[#1f1f1f] min-h-screen font-serif text-gray-200">
            <nav className="bg-[#141414] border-b border-[#333] px-8 py-6 flex justify-between items-center sticky top-0 z-50">
                <div className="text-xl font-medium tracking-widest text-[#d4af37] uppercase">
                    {schoolName}
                </div>
                <div className="hidden md:flex gap-8 text-sm uppercase tracking-widest text-gray-400">
                    <a href="#" className="hover:text-white transition-colors">Membership</a>
                    <a href="#" className="hover:text-white transition-colors">Advisory</a>
                    <a href="#" className="hover:text-white transition-colors">Insights</a>
                </div>
                <Button variant="outline" className="border-[#d4af37] text-[#d4af37] hover:bg-[#d4af37] hover:text-black uppercase text-xs tracking-widest rounded-none">
                    Member Login
                </Button>
            </nav>

            <main>
                <section className="relative h-[80vh] flex items-center justify-center bg-[#1f1f1f] overflow-hidden">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#333] via-[#1f1f1f] to-[#141414]"></div>
                    <div className="relative z-10 text-center max-w-4xl px-4">
                        <span className="text-[#d4af37] uppercase tracking-[0.3em] text-sm mb-6 block font-bold">
                            Leadership Refined
                        </span>
                        <h1 className="text-5xl md:text-7xl font-light text-white mb-8 leading-tight">
                            Command the Future <br/> of Industry.
                        </h1>
                        <p className="text-xl text-gray-400 mb-12 font-light max-w-2xl mx-auto leading-relaxed">
                            An exclusive educational environment for high-performing executives and future global leaders.
                        </p>
                        <div className="flex justify-center gap-6">
                            <Button className="bg-[#d4af37] text-black hover:bg-white hover:text-black rounded-none px-10 py-6 uppercase tracking-widest text-xs font-bold">
                                Apply for Access
                            </Button>
                        </div>
                    </div>
                </section>

                <section className="py-24 bg-[#141414] border-t border-[#333]">
                    <div className="container mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-12 text-center">
                        <div className="p-8 border border-[#333] hover:border-[#d4af37] transition-all group">
                            <Gem size={32} className="mx-auto mb-6 text-[#555] group-hover:text-[#d4af37] transition-colors" />
                            <h3 className="text-xl text-white mb-4 uppercase tracking-wide">Exclusivity</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">Limitless access to a network of elite peers.</p>
                        </div>
                        <div className="p-8 border border-[#333] hover:border-[#d4af37] transition-all group">
                            <ShieldCheck size={32} className="mx-auto mb-6 text-[#555] group-hover:text-[#d4af37] transition-colors" />
                            <h3 className="text-xl text-white mb-4 uppercase tracking-wide">Legacy</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">Building foundations that last generations.</p>
                        </div>
                        <div className="p-8 border border-[#333] hover:border-[#d4af37] transition-all group">
                            <Award size={32} className="mx-auto mb-6 text-[#555] group-hover:text-[#d4af37] transition-colors" />
                            <h3 className="text-xl text-white mb-4 uppercase tracking-wide">Prestige</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">Recognized globally as a standard of excellence.</p>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default ExecutiveSuite;
